<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="CHAPTER1" id="uMjE4GafG3l7vcLaLFUEPFD"> </p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5">Solved</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5">Serial Killer</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5">Cases</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5"> </span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5">Book 3</span></p>
<p class="Normal ParaOverride-2"><span class="CharOverride-5">M - S</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?07c46cc1